import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ExtractorPdfState } from "./type";

const initialState: ExtractorPdfState = {
  files: []
};

const extractorPdfSlice = createSlice({
  name: "extractorPdfIcms",
  initialState,
  reducers: {
    setFiles(state, action: PayloadAction<File[]>) {
      state.files = action.payload;
    },
    clearFiles(state) {
      state.files = [];
    },
    reset() {
      return initialState;
    },
  },
});

export const { setFiles, clearFiles, reset } = extractorPdfSlice.actions;
export default extractorPdfSlice.reducer;
